import { computed, Ref } from 'vue';
import { LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

export const useItem = (item: Ref<LegacyItem>) => {
  const { isTranslationEnabled } = useInspectionReport();

  const title = computed(() => {
    return isTranslationEnabled.value && item.value.title_translated
      ? item.value.title_translated
      : item.value.title;
  });

  return {
    title,
  };
};
